import * as actionTypes from './actionTypes';
import * as actions from './index';
import { updateObject } from '../utility';


export const adminSaveUserStart = () => {
    return {
        type: actionTypes.ADMIN_SAVE_USER_START
    };
};

export const adminSaveUserSuccess = (user) => {
    return {
        type: actionTypes.ADMIN_SAVE_USER_SUCCESS,
        payload: { user: user, lastaction: 'saveuser' }
    };
};

export const adminSaveUserFail = (error) => {
    return {
        type: actionTypes.ADMIN_SAVE_USER_FAIL,
        error: error
    };
};

export const adminSaveNewUserStart = () => {
    return {
        type: actionTypes.ADMIN_SAVE_NEW_USER_START
    };
};

export const adminSaveNewUserSuccess = (user) => {
    return {
        type: actionTypes.ADMIN_SAVE_NEW_USER_SUCCESS,
        payload: { user: user, lastaction: 'savenewuser' }
    };
};

export const adminSaveNewUserFail = (error) => {
    return {
        type: actionTypes.ADMIN_SAVE_NEW_USER_FAIL,
        error: error
    };
};

export const adminDeleteUserStart = () => {
    return {
        type: actionTypes.ADMIN_DELETE_USER_START
    };
};

export const adminDeleteUserSuccess = (userid) => {
    return {
        type: actionTypes.ADMIN_DELETE_USER_SUCCESS,
        payload: { user: userid, lastaction: 'deleteuser' }
    };
};

export const adminDeleteUserFail = (error) => {
    return {
        type: actionTypes.ADMIN_DELETE_USER_FAIL,
        error: error
    };
};


export const adminGetUsersStart = () => {
    return {
        type: actionTypes.ADMIN_GET_USERS_START
    };
};

export const adminGetUsersSuccess = (users) => {
    return {
        type: actionTypes.ADMIN_GET_USERS_SUCCESS,
        payload: { users: users }
    };
};

export const adminGetUsersFail = (error) => {
    return {
        type: actionTypes.ADMIN_GET_USERS_FAIL,
        error: error
    };
};
export const adminGrantingReadSuccess = (granting) => {
    return {
        type: actionTypes.ADMIN_SET_GRANTING,
        payload: { granting: granting }
    }
}
export const adminGetAllGrantsSuccess = (grants) => {
    return {
        type: actionTypes.ADMIN_SET_ALL_GRANTS,
        payload: { grants: grants }
    }
}
export const adminGetAllGrantsStart = () => {
    return {
        type: actionTypes.ADMIN_GET_ALL_GRANTS_START
    }
}

export const adminGetAllGrantsFail = () => {
    return {
        type: actionTypes.ADMIN_GET_ALL_GRANTS_FAIL
    }
}

export const adminSetEditUser = (user) => {
    return {
        type: actionTypes.ADMIN_SET_EDITUSER,
        payload: { user: user }
    }
}

export const adminGetAllGrants = () => {
    return dispatch => {
        dispatch(adminGetAllGrantsStart());
        window.flow.grantingGetDefined().then(res => {
            console.log(res);
            dispatch(adminGetAllGrantsSuccess(res));
        }).catch((res) => {
            console.log(res);
            dispatch(adminGetAllGrantsFail());
        })
    }
}

export const adminGetUsers = () => {
    return dispatch => {
        dispatch(adminGetUsersStart());
        window.flow.getUsersByFields().then((res) => {
            dispatch(adminGetUsersSuccess(res.user.elements));
            window.flow.grantingRoleGetAll().then(res => {
                dispatch(adminGrantingReadSuccess(res));
            })
        }).catch(res => {
            console.log(res);
            dispatch(adminGetUsersFail(res));
        })
    }
}

export const adminSetUserData = (id, data) => {
    console.log(id, data);
    return dispatch => {
        dispatch(adminSaveUserStart());
        window.flow.userSetData(id, data).then((res) => {
            console.log(res);
            let user = {
                ...res.user.data,
                email: res.user.email,
                first_name: res.user.first_name,
                last_name: res.user.last_name,
                lastactivity: res.user.lastactivity,
                metadata: res.user.data.metadata.fields || {}
            };

            dispatch(adminSaveUserSuccess(user));

            dispatch(actions.addMessage("popup.title.user.save.success", null, 'text', 'dialog'));
        }).catch(res => {
            dispatch(adminSaveUserFail());
            dispatch(actions.addMessage("popup.title.user.save.fail", null, 'text', 'dialog'));
        });

    }

}

export function adminSaveUser(userData, messages) {
    console.log(userData);
    return dispatch => {
        dispatch(adminSaveUserStart());
        //window.flow.grantingUserSetRole(group, user, role).then((res) => {
        // window.flow.userSetData(userData.id, { id: userData.id, username: userData.username, email: userData.email, metadata: { first_name: userData.first_name, last_name: userData.last_name } }).then((res) => {
        window.flow.userSetData(userData.id, {
            userid: userData.id,
            username: userData.username,
            email: userData.email,
            last_name: userData.last_name,
            first_name: userData.first_name,
            metadata: { ...userData.metadata, first_name: userData.first_name, last_name: userData.last_name }
        }).then((res) => {
            console.log(res);
            let user = {
                ...res.user.data,
                email: res.user.email,
                first_name: res.user.first_name,
                last_name: res.user.last_name,
                lastactivity: res.user.lastactivity,
                metadata: res.user.data.metadata.fields || {}
            };

            user.role = userData.role;
            dispatch(adminSaveUserSuccess(user));

            if (userData.password !== '') {
                window.flow.userSetPassword(userData.id, userData.password);
            }
            window.flow.grantingUserSetRole(res.groupid, res.userid, userData.role)
            dispatch(actions.addMessage("popup.title.user.save.success", null, 'text', 'dialog'));
        }).catch(res => {
            dispatch(adminSaveUserFail());
            dispatch(actions.addMessage("popup.title.user.save.fail", null, 'text', 'dialog'));
        });

    }

}
export function adminSaveNewUser(userData, messages) {
    return (dispatch, getState) => {
        dispatch(adminSaveNewUserStart());
        console.log(userData);
        window.flow.newUser(userData.username, userData.email, { usertype: 1, password: userData.password, metadata: { ...userData.metadata, first_name: userData.first_name, last_name: userData.last_name } }).then((res) => {
            let user = {
                ...res.user.data,
                email: res.user.email,
                first_name: res.user.first_name,
                last_name: res.user.last_name,
                lastactivity: res.user.lastactivity,
                metadata: res.user.data.metadata.fields || {}
            };
            user.role = userData.role;
            dispatch(adminSaveNewUserSuccess(user));
            window.flow.grantingUserSetRole(res.groupid, res.userid, userData.role).then((res1) => {
                //dispatch(adminSaveUserSuccess(res1))
            });

            dispatch(actions.getUserLimit(getState().app.modules.modules));

        }).catch(res => {
            console.log(res);
            dispatch(adminSaveNewUserFail());
            let msg = '';
            if (res.resultid && res.resultid > 1 && res.resultid < 10) {
                msg = "popup.admin.user.create.error." + res.resultid;
            }
            dispatch(actions.addMessage("popup.title.user.create.fail", msg, 'text', 'dialog'));
        });
    }
}

export function adminDeleteUser(id, messages) {
    return (dispatch, getState) => {
        dispatch(adminDeleteUserStart());
        console.log(id);
        window.flow.delUser(id).then((res) => {

            dispatch(adminDeleteUserSuccess(id));
            dispatch(actions.getUserLimit(getState().app.modules.modules));
        }).catch(res => {
            console.log(res);
            if (res.indexOf('deleted user') !== -1) {
                dispatch(adminDeleteUserSuccess(id));
            } else {
                dispatch(adminDeleteUserFail());
                dispatch(actions.addMessage("popup.title.user.delete.fail", null, 'text', 'dialog'));
            }
        });
    }
}

export function loadUserSetting(groupid, id) {
    return dispatch => {
        dispatch({ type: actionTypes.ADMIN_LOAD_USER_SETTING_START });
        window.flow.grantingGetUser(groupid, id).then((res) => {
            dispatch({ type: actionTypes.ADMIN_LOAD_USER_SETTING_SUCCESS, setting: res.elements });
        }).catch(res => {
            dispatch({ type: actionTypes.ADMIN_LOAD_USER_SETTING_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    }
}

export function saveUserSetting(groupid, id, setting) {
    const keys = Object.keys(setting);
    const grantings = [];

    keys.forEach(key => {
        grantings.push({ name: key, value: setting[key] });
    });

    return dispatch => {
        dispatch({ type: actionTypes.ADMIN_SAVE_USER_SETTING_START });
        window.flow.grantingEditUser(groupid, id, grantings).then((res) => {
            dispatch({ type: actionTypes.ADMIN_SAVE_USER_SETTING_SUCCESS });
            dispatch(actions.addMessage("popup.title.admin.granting.save.success", null, 'text', 'dialog'));
        }).catch(res => {
            dispatch({ type: actionTypes.ADMIN_SAVE_USER_SETTING_FAIL });
            dispatch(actions.addMessage("popup.title.admin.granting.save.fail", null, 'text', 'dialog'));
            dispatch(actions.applicationError(res.message));
        });
    }
}

export function loadGroupSetting(groupid) {
    return dispatch => {
        dispatch({ type: actionTypes.ADMIN_LOAD_GROUP_SETTING_START });
        window.flow.grantingGetGroup(groupid).then((res) => {
            console.log(res);
            dispatch({ type: actionTypes.ADMIN_LOAD_GROUP_SETTING_SUCCESS, id: groupid, setting: res.elements });
        }).catch(res => {
            dispatch({ type: actionTypes.ADMIN_LOAD_GROUP_SETTING_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    }
}

export function saveGroupSetting(groupid, setting) {
    const keys = Object.keys(setting);
    const grantings = [];

    keys.forEach(key => {
        grantings.push({ name: key, value: setting[key] });
    });

    return dispatch => {
        dispatch({ type: actionTypes.ADMIN_SAVE_GROUP_SETTING_START });
        window.flow.grantingEditGroup(groupid, grantings).then((res) => {
            dispatch({ type: actionTypes.ADMIN_SAVE_GROUP_SETTING_SUCCESS });
            dispatch(actions.loadGroupSetting(groupid));
        }).catch(res => {
            dispatch({ type: actionTypes.ADMIN_SAVE_GROUP_SETTING_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    }
}

